import script from "./AidCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AidCard.vue?vue&type=script&setup=true&lang=ts"

import "./AidCard.vue?vue&type=style&index=0&id=126fb05e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-126fb05e"]])

export default __exports__